<template>
  <CardAction :style="cardStyle">
    <div :style="containerStyle">
      <div v-if="header.length > 0"
           :style="headerStyle">
        {{ header }}
      </div>
      <div :style="textContainerStyle">
        <slot name="content" />
      </div>
      <slot name="button">
        <ButtonPrimary v-if="action"
                       @click="action">
          <GoogleMaterialIconPrimary
            :color="iconColor"
            content="add"
          />
        </ButtonPrimary>
      </slot>
    </div>
  </CardAction>
</template>

<script>
  import ButtonPrimary from '@modules/v2/button/button-primary'
  import CardAction from '@modules/card/card-action'
  import GoogleMaterialIconPrimary from '@modules/v2/icon/google-material-icon-primary'
  import { FontStyle, Layout } from '@js/styles'
  import { mapGetters } from 'vuex'

  export default {
    name: 'ItemActionCardPrimary',
    components: {
      ButtonPrimary,
      CardAction,
      GoogleMaterialIconPrimary,
    },
    props: {
      action: { type: Function, required: false, default: () => null },
      header: { type: String, required: false, default: '' },
    },
    data: function () {
      return {
        cardStyle: {
          flex: 1,
          height: '176px',
          margin: `${Layout.space.md} 12px 0 12px`,
          minWidth: '240px',
          padding: Layout.space.md,
        },
        containerStyle: {
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          justifyContent: 'space-between',
        },
        headerStyle: {
          fontSize: FontStyle.size.md,
          fontWeight: FontStyle.weight.xl,
          lineHeight: 1.2,
        },
        iconColor: 'none',
        textContainerStyle: {
          fontSize: FontStyle.size.md,
          fontWeight: FontStyle.weight.md,
          textAlign: 'center',
        },
      };
    },
    created: function () {
      this.iconColor = this.color.light1();

      this.headerStyle = {
        ...this.headerStyle,
        color: this.color.light1(),
      };

      this.textContainerStyle = {
        ...this.textContainerStyle,
        color: this.color.light1(),
      };
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
    },
  };
</script>
